import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@lib/auth/use-auth.ts'

const CallbackComponent = () => {
    const { isLoading } = useAuth();
    return (
        <div>
            {isLoading ? 'Completing login...' : 'Redirecting...'}
        </div>
    );
};

export const Route = createFileRoute('/callback')({
    component: CallbackComponent,
})
